import { Link } from 'react-router';
import { Plus } from 'lucide-react';
import { Header } from '@/components/layout/Header';
import { PageBody } from '@/components/layout/PageBody';
import { useProject } from '@/contexts/ProjectContext';
import { WorkflowList } from '@/components/workflows/WorkflowList';
import { WorkflowRecommendationBanner } from '@/components/workflows/WorkflowRecommendationBanner';

export function WorkflowsPage(): React.ReactElement {
  const { selectedProjectId, codebases } = useProject();
  const codebase = codebases?.find(cb => cb.id === selectedProjectId);

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <Header title="Workflows" projectName={codebase?.name} />
      <PageBody maxWidthClassName="max-w-7xl" contentClassName="space-y-5">
        <section className="rounded-2xl border border-border/70 bg-surface/90 p-5 shadow-sm backdrop-blur-sm">
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div className="space-y-1">
              <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-text-tertiary">
                Workflow Library
              </p>
              <h2 className="text-2xl font-semibold tracking-tight text-text-primary">
                Run, inspect, and refine your automation loops
              </h2>
              <p className="max-w-2xl text-sm text-text-secondary">
                Use saved workflows as repeatable operating patterns, then open the builder when a
                loop needs a new branch, gate, or orchestration path.
              </p>
            </div>
            <Link
              to="/workflows/builder"
              className="inline-flex items-center justify-center gap-1.5 rounded-xl bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground shadow-sm transition-colors hover:bg-primary/90"
            >
              <Plus className="size-4" />
              New Workflow
            </Link>
          </div>
        </section>

        {selectedProjectId && <WorkflowRecommendationBanner codebaseId={selectedProjectId} />}

        <section className="min-h-0 rounded-2xl border border-border/70 bg-surface/90 p-4 shadow-sm backdrop-blur-sm">
          <WorkflowList />
        </section>
      </PageBody>
    </div>
  );
}
